import { PHOTO_URLS_FETCHED } from '../actions/actionTypes';

const initialState = {
  urls: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PHOTO_URLS_FETCHED:
      return {
        ...state,
        urls: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/photos.js